export default __webpack_public_path__ + "static/media/H1006.2.66f6bfc4.mp3";